// 后台业务操作：英文字段。只维护显示文案，不改业务标识、数值或提交内容。
// 管理流程
export const flows = Object.freeze({
  "adminFlows.loading": "Loading...",
  "adminFlows.updating": "Updating...",
  "adminFlows.publishing": "Publishing...",
  "adminFlows.recognizedAndFilledCountProducts":
    "Recognized and filled {count} products",
  "adminFlows.noProductDetailsTheOrderCannotBePlaced":
    "No product details. The order cannot be placed",
  "adminFlows.someProductSpecificationsAreNoLongerAvailableGoBackAndSelectAgain":
    "Some product specifications are no longer available. Go back and select again",
  "adminFlows.completeTheProductInformation":
    "Complete the product information",
  "adminFlows.enterTheBrand": "Enter the brand",
  "adminFlows.enterAPartNumber": "Enter a part number",
  "adminFlows.enterAPriceGreaterThanZero": "Enter a price greater than zero",
  "adminFlows.enterTheQuantity": "Enter the quantity",
  "adminFlows.enterAQuantityGreaterThanZero":
    "Enter a quantity greater than zero",
  "adminFlows.membershipLevels": "Membership levels",
  "adminFlows.levelName": "Level name",
  "adminFlows.requiredPoints": "Required points",
  "adminFlows.tradeDiscount": "Trade discount",
  "adminFlows.members": "Members",
  "adminFlows.benefits": "Benefits",
  "adminFlows.status": "Status",
  "adminFlows.enabled": "Enabled",
  "adminFlows.disabled": "Disabled",
  "adminFlows.actions": "Actions",
  "adminFlows.edit": "Edit",
  "adminFlows.delete": "Delete",
  "adminFlows.levelApplications": "Level applications",
  "adminFlows.assignLevel": "Assign level",
  "adminFlows.applicant": "Applicant",
  "adminFlows.currentLevel": "Current level",
  "adminFlows.requestedLevel": "Requested level",
  "adminFlows.applicationReason": "Application reason",
  "adminFlows.appliedAt": "Applied at",
  "adminFlows.approve": "Approve",
  "adminFlows.reject": "Reject",
  "adminFlows.membershipBenefits": "Membership benefits",
  "adminFlows.requiredPointsLabel": "Required points:",
  "adminFlows.tradeDiscountLabel": "Trade discount:",
  "adminFlows.memberCountLabel": "Members:",
  "adminFlows.benefitsLabel": "Benefits:",
  "adminFlows.assignMembershipLevel": "Assign membership level",
  "adminFlows.selectMember": "Select member",
  "adminFlows.selectASalesperson": "Select a salesperson",
  "adminFlows.targetLevel": "Target level",
  "adminFlows.selectALevel": "Select a level",
  "adminFlows.reason": "Reason",
  "adminFlows.enterAReason": "Enter a reason",
  "adminFlows.cancel": "Cancel",
  "adminFlows.confirmAssignment": "Confirm assignment",
  "adminFlows.editMembershipLevel": "Edit membership level",
  "adminFlows.enterRequiredPoints": "Enter required points",
  "adminFlows.selectADiscount": "Select a discount",
  "adminFlows.enterBenefitDetails": "Enter benefit details",
  "adminFlows.saveChanges": "Save changes",
  "adminFlows.unableToLoadMembershipLevelsPleaseTryAgain":
    "Unable to load membership levels. Please try again.",
  "adminFlows.approved": "Approved",
  "adminFlows.rejected": "Rejected",
  "adminFlows.pendingReview": "Pending review",
  "adminFlows.selectAMemberAndTargetLevel": "Select a member and target level",
  "adminFlows.membershipLevelAssigned": "Membership level assigned",
  "adminFlows.completeTheRequiredInformation":
    "Complete the required information",
  "adminFlows.membershipLevelUpdated": "Membership level updated",
  "adminFlows.notice": "Notice",
  "adminFlows.confirm": "Confirm",
  "adminFlows.deletedSuccessfully": "Deleted successfully",
  "adminFlows.levelApplicationApproved": "Level application approved",
  "adminFlows.levelApplicationRejected": "Level application rejected",
  "adminFlows.noDiscount": "No discount",
  "adminFlows.discount99": "1% off",
  "adminFlows.discount98": "2% off",
  "adminFlows.discount97": "3% off",
  "adminFlows.discount95": "5% off",
  "adminFlows.discount93": "7% off",
  "adminFlows.discount9": "10% off",
  "adminFlows.discount88": "12% off",
  "adminFlows.discount85": "15% off",
  "adminFlows.membershipIdentities": "Membership identities",
  "adminFlows.identityName": "Identity name",
  "adminFlows.participantCount": "Members",
  "adminFlows.defaultLevel": "Default level",
  "adminFlows.maximumLevel": "Maximum level",
  "adminFlows.permissions": "Permissions",
  "adminFlows.createdAt": "Created at",
  "adminFlows.salespersonManagement": "Salesperson management",
  "adminFlows.account": "Account",
  "adminFlows.name": "Name",
  "adminFlows.company": "Company",
  "adminFlows.mobileNumber": "Mobile number",
  "adminFlows.membershipLevel": "Membership level",
  "adminFlows.active": "Active",
  "adminFlows.frozen": "Frozen",
  "adminFlows.unfreeze": "Unfreeze",
  "adminFlows.customerManagement": "Customer management",
  "adminFlows.contact": "Contact",
  "adminFlows.companyName": "Company name",
  "adminFlows.transactions": "Transactions",
  "adminFlows.supplierManagement": "Supplier management",
  "adminFlows.supplierName": "Supplier name",
  "adminFlows.supplyType": "Supply type",
  "adminFlows.yearsOfCooperation": "Years of cooperation",
  "adminFlows.partnerManagement": "Partner management",
  "adminFlows.partnerName": "Partner name",
  "adminFlows.cooperationType": "Cooperation type",
  "adminFlows.enterAContactName": "Enter a contact name",
  "adminFlows.enterACompanyName": "Enter a company name",
  "adminFlows.enterAMobileNumber": "Enter a mobile number",
  "adminFlows.selectAMembershipLevel": "Select a membership level",
  "adminFlows.enterASupplyType": "Enter a supply type",
  "adminFlows.enterACooperationType": "Enter a cooperation type",
  "adminFlows.editIdentity": "Edit identity",
  "adminFlows.selectADefaultLevel": "Select a default level",
  "adminFlows.selectAMaximumLevel": "Select a maximum level",
  "adminFlows.salesperson": "Salesperson",
  "adminFlows.customer": "Customer",
  "adminFlows.supplier": "Supplier",
  "adminFlows.partner": "Partner",
  "adminFlows.member": "Member",
  "adminFlows.unableToLoadMembershipIdentitiesPleaseTryAgain":
    "Unable to load membership identities. Please try again.",
  "adminFlows.updatedSuccessfully": "Updated successfully",
  "adminFlows.deleteThisIdentity": "Delete this identity?",
  "adminFlows.enterTheContactNameAndMobileNumber":
    "Enter the contact name and mobile number",
  "adminFlows.myCustomers": "My customers",
  "adminFlows.customerId": "Customer ID",
  "adminFlows.customerName": "Customer name",
  "adminFlows.noCustomersYet": "No customers yet",
  "adminFlows.findCustomers": "Find customers",
  "adminFlows.myOrders": "My orders",
  "adminFlows.period": "Period",
  "adminFlows.brand": "Brand",
  "adminFlows.partNumber": "Part number",
  "adminFlows.type": "Type",
  "adminFlows.bidPrice": "Bid price",
  "adminFlows.bidQuantity": "Bid quantity",
  "adminFlows.bidTime": "Bid time",
  "adminFlows.pcs": "pcs",
  "adminFlows.noOrdersYet": "No orders yet",
  "adminFlows.viewBidding": "View bidding",
  "adminFlows.unableToLoadCustomers": "Unable to load customers",
  "adminFlows.biddingOpen": "Bidding open",
  "adminFlows.pendingOpening": "Pending opening",
  "adminFlows.won": "Won",
  "adminFlows.notWon": "Not won",
  "adminFlows.biddingClosed": "Bidding closed",
  "adminFlows.opened": "Opened",
  "adminFlows.back": "Back",
  "adminFlows.productInformation": "Product information",
  "adminFlows.aiRecognition": "AI recognition",
  "adminFlows.enterTextOrPasteAProductImage":
    "Enter text or paste a product image",
  "adminFlows.recognitionImagePreview": "Recognition image preview",
  "adminFlows.imageRecognition": "Image recognition",
  "adminFlows.speechRecognition": "Speech recognition",
  "adminFlows.recognizeAndFill": "Recognize and fill",
  "adminFlows.orderType": "Order type",
  "adminFlows.privateOrder": "Private order",
  "adminFlows.sendToASpecificBuyerEnterTheBuyerPhoneNumber":
    "Send to a specific buyer; enter the buyer phone number",
  "adminFlows.buyerPhone": "Buyer phone",
  "adminFlows.enterTheBuyerPhoneNumber": "Enter the buyer phone number",
  "adminFlows.publicOrder": "Public order",
  "adminFlows.publishPubliclyWithoutASpecificBuyerPhoneNumber":
    "Publish publicly without a specific buyer phone number",
  "adminFlows.productCategory": "Product category",
  "adminFlows.selectAProductCategory": "Select a product category",
  "adminFlows.uploadImages": "Upload images",
  "adminFlows.dragToUploadOrReorderDoubleClickToPreview":
    "(Drag to upload or reorder; double-click to preview)",
  "adminFlows.uploadProductImages": "Upload product images",
  "adminFlows.productName": "Product name",
  "adminFlows.enterAProductName": "Enter a product name",
  "adminFlows.enterABrandName": "Enter a brand name",
  "adminFlows.selectBrand": "Select brand",
  "adminFlows.unitPrice": "Unit price",
  "adminFlows.enterAUnitPrice": "Enter a unit price",
  "adminFlows.approx": "Approx. ",
  "adminFlows.quantityUnit": "Quantity / unit",
  "adminFlows.enterQuantity": "Enter quantity",
  "adminFlows.enterUnit": "Enter unit",
  "adminFlows.deliveryAddress": "Delivery address",
  "adminFlows.enterADeliveryAddress": "Enter a delivery address",
  "adminFlows.dateCodeDc": "Date code (DC)",
  "adminFlows.enterADateCode": "Enter a date code",
  "adminFlows.goodsCondition": "Goods condition",
  "adminFlows.multipleSelection": "(Multiple selection)",
  "adminFlows.noCategoryAttributesSelectASubcategory":
    "No category attributes. Select a subcategory.",
  "adminFlows.additionalInformation": "Additional information",
  "adminFlows.expand": "Expand",
  "adminFlows.datasheet": "Datasheet",
  "adminFlows.uploadDatasheet": "Upload datasheet",
  "adminFlows.manufacturer": "Manufacturer",
  "adminFlows.enterAManufacturer": "Enter a manufacturer",
  "adminFlows.weight": "Weight",
  "adminFlows.enterWeight": "Enter weight",
  "adminFlows.g": "g",
  "adminFlows.dimensions": "Dimensions",
  "adminFlows.length": "Length",
  "adminFlows.mm": "mm",
  "adminFlows.width": "Width",
  "adminFlows.height": "Height",
  "adminFlows.alternativeProducts": "Alternative products",
  "adminFlows.addAlternativeProduct": "Add alternative product",
  "adminFlows.applications": "Applications",
  "adminFlows.separateWithSpacesOrCommasPressEnterToConfirm":
    "Separate with spaces or commas; press Enter to confirm",
  "adminFlows.minimumOrderQuantity": "Minimum order quantity",
  "adminFlows.enterMinimumOrderQuantity": "Enter minimum order quantity",
  "adminFlows.validUntil": "Valid until",
  "adminFlows.selectValidityDate": "Select validity date",
  "adminFlows.leadTime": "Lead time",
  "adminFlows.enterEstimatedLeadTime": "Enter estimated lead time",
  "adminFlows.businessDays": "business days",
  "adminFlows.ownerCompany": "Goods owner company",
  "adminFlows.enterTheGoodsOwnerCompanyName":
    "Enter the goods owner company name",
  "adminFlows.remarks": "Remarks",
  "adminFlows.enterProductRemarks": "Enter product remarks",
  "adminFlows.collapse": "Collapse",
  "adminFlows.purchaseRequirements": "Purchase requirements",
  "adminFlows.productPrice": "Product price",
  "adminFlows.enterProductPrice": "Enter product price",
  "adminFlows.quantity": "Quantity",
  "adminFlows.enterPurchaseQuantity": "Enter purchase quantity",
  "adminFlows.buyerInformation": "Buyer information",
  "adminFlows.companyNameRequired": "Enter a company name",
  "adminFlows.taxId": "Tax ID",
  "adminFlows.enterATaxId": "Enter a tax ID",
  "adminFlows.contactNameRequired": "Enter a contact name",
  "adminFlows.contactDetails": "Contact details",
  "adminFlows.enterContactDetails": "Enter contact details",
  "adminFlows.uploadOrderInformation": "Upload order information",
  "adminFlows.orderInformation": "Order information",
  "adminFlows.saveDraft": "Save draft",
  "adminFlows.searchByCategoryName": "Search by category name",
  "adminFlows.selectDate": "Select date",
  "adminFlows.selectADate": "Select a date",
  "adminFlows.publishFeaturedProduct": "Publish featured product",
  "adminFlows.useAvailableDetailsToPublishAProductQuickly":
    "Use available details to publish a product quickly",
  "adminFlows.confirmPublication": "Confirm publication",
  "adminFlows.quickOrder": "Quick order",
  "adminFlows.editFeaturedProduct": "Edit featured product",
  "adminFlows.updateProductDetailsAndSubmitForReview":
    "Update product details and submit for review",
  "adminFlows.confirmChanges": "Confirm changes",
  "adminFlows.required": "Required",
  "adminFlows.enterAValidNumber": "Enter a valid number",
  "adminFlows.enterAPositiveInteger": "Enter a positive integer",
  "adminFlows.cannotBeEmpty": "Required",
  "adminFlows.selectGoodsCondition": "Select goods condition",
  "adminFlows.datasheetAttachment": "Datasheet attachment",
  "adminFlows.pleaseSignInFirst": "Please sign in first",
  "adminFlows.onlyJpgPngAndWebpImagesAreSupported":
    "Only JPG, PNG and WEBP images are supported",
  "adminFlows.imageMustNotExceed10Mb": "Image must not exceed 10 MB",
  "adminFlows.speechRecognitionIsNotSupportedByThisBrowser":
    "Speech recognition is not supported by this browser",
  "adminFlows.speechRecognitionFailedPleaseTryAgain":
    "Speech recognition failed. Please try again.",
  "adminFlows.enterTextOrSelectAnImageFirst":
    "Enter text or select an image first",
  "adminFlows.noUsableProductInformationRecognized":
    "No usable product information recognized",
  "adminFlows.recognizedAndFilledSuccessfully":
    "Recognized and filled successfully",
  "adminFlows.recognitionFailedPleaseTryAgain":
    "Recognition failed. Please try again.",
  "adminFlows.unableToLoadProductInformation":
    "Unable to load product information",
  "adminFlows.unableToLoadProductInformationPleaseTryAgain":
    "Unable to load product information. Please try again.",
  "adminFlows.quickOrderCreated": "Quick order created",
  "adminFlows.draftSaved": "Draft saved",
  "adminFlows.selectAnOrderType": "Select an order type",
  "adminFlows.selectAValidOrderType": "Select a valid order type",
  "adminFlows.publishedSuccessfully": "Published successfully",
  "adminFlows.completeAllInformation": "Complete the required information",
  "adminFlows.selectASubcategory": "Select a subcategory",
  "adminFlows.enterAnAlternativeBrand": "Enter an alternative brand",
  "adminFlows.enterAnAlternativePartNumber": "Enter an alternative part number",
  "adminFlows.suggestedTags": "Suggested tags:",
  "adminFlows.computers": "Computers",
  "adminFlows.mobilePhones": "Mobile phones",
  "adminFlows.automotive": "Automotive",
  "adminFlows.iot": "IoT",
  "adminFlows.networking": "Networking",
  "adminFlows.hongKongChina": "Hong Kong, China",
  "adminFlows.mainlandChina": "Mainland China",
  "adminFlows.newAndOriginal": "New and original",
  "adminFlows.original": "Original",
  "adminFlows.salvaged": "Salvaged",
  "adminFlows.newLoosePackaging": "New, loose packaging",
  "adminFlows.deleteMembershipLevelConfirmation":
    "Delete membership level {level}?",
  "adminFlows.approveLevelApplicationConfirmation":
    "Approve the level application from {name}?",
  "adminFlows.rejectLevelApplicationConfirmation":
    "Reject the level application from {name}?",
  "adminFlows.levelPointsOption": "{level} (points >= {points})",
  "adminFlows.editType": "Edit {type}",
  "adminFlows.entityActionConfirmation": "{action} this {type}?",
  "adminFlows.actionCompleted": "{action} completed",
  "adminFlows.deleteEntityConfirmation": "Delete this {type}?",
  "adminFlows.enterField": "Enter {field}",
  "adminFlows.certificateOfOriginCount": "Certificate of origin {count}",
  "adminFlows.recognizedCountProductsOnlyTheFirstIsFilled":
    "Recognized {count} products; only the first is filled",
  "adminFlows.upToMaxTagsAreAllowed": "Up to {max} tags are allowed",
});

// 数据看板：只维护显示文字，不改变原始工作表、筛选值或业务数据。
export const reportDashboard = Object.freeze({
  "reportDashboard.title": "Business dashboard",
  "reportDashboard.summaryHint":
    "Completed trades only · By order creation date · CNY business remains unclassified and is counted once",
  "reportDashboard.dataSource": "Data source",
  "reportDashboard.remoteSource": "Server query",
  "reportDashboard.reportType": "Report type",
  "reportDashboard.salesDashboard": "Sales dashboard",
  "reportDashboard.purchaseDashboard": "Purchase cost dashboard",
  "reportDashboard.exportFiltered": "Export filtered results",
  "reportDashboard.viewDenied":
    "Your account does not have access to this dashboard",
  "reportDashboard.filters": "Dashboard filters",
  "reportDashboard.allCompanies": "All own companies",
  "reportDashboard.startDate": "Order creation start date",
  "reportDashboard.endDate": "End date",
  "reportDashboard.allCustomers": "All customers",
  "reportDashboard.allSuppliers": "All suppliers",
  "reportDashboard.allModels": "All part numbers",
  "reportDashboard.businessSource": "Business category",
  "reportDashboard.allSources": "All business categories",
  "reportDashboard.cnySource": "CNY business / unclassified",
  "reportDashboard.usdSource": "USD business",
  "reportDashboard.allCurrencies": "All currencies",
  "reportDashboard.cnyCurrency": "Chinese yuan CNY",
  "reportDashboard.usdCurrency": "US dollar USD",
  "reportDashboard.unitPlaceholder": "Quantity unit (optional)",
  "reportDashboard.keywordPlaceholder": "Order no. / part no. / product name",
  "reportDashboard.search": "Search",
  "reportDashboard.reset": "Reset",
  "reportDashboard.facetsTruncated":
    "Only the first 100 filter options are shown. Narrow your search.",
  "reportDashboard.readFailureHint":
    "The query failed. No Excel or demo fallback is used. Any content below is from the last successful query.",
  "reportDashboard.reading": "Loading…",
  "reportDashboard.filtersChanged":
    "Filters have changed. Select Search. The previous results are still shown.",
  "reportDashboard.generatedAt":
    "Overview queried at {time} (each query has its own timestamp)",
  "reportDashboard.notRead": "Not loaded",
  "reportDashboard.overview": "Business overview",
  "reportDashboard.salesDetailCount": "Sales detail count",
  "reportDashboard.purchaseDetailCount": "Purchase detail count",
  "reportDashboard.customerCount": "Customer count",
  "reportDashboard.supplierCount": "Supplier count",
  "reportDashboard.quantityTotal": "Total product quantity · {unit}",
  "reportDashboard.salesAmount": "Sales amount",
  "reportDashboard.purchaseCost": "Purchase cost",
  "reportDashboard.missingDataWarning":
    "Some records have no amount or counterparty. Check the source orders; missing amounts are not filled in.",
  "reportDashboard.monthlyTrend": "Monthly product quantity trend",
  "reportDashboard.selectUnit": "Select a unit",
  "reportDashboard.trendAccessibleLabel":
    "Monthly quantity trend, unit {unit}, currency {currency}",
  "reportDashboard.noTrend": "No trend data for this unit and currency",
  "reportDashboard.trendHint":
    "Trends use the same unit and currency. Amounts are not recalculated in the browser.",
  "reportDashboard.customerRanking": "Customers by amount",
  "reportDashboard.supplierRanking": "Suppliers by amount",
  "reportDashboard.unknownCounterparty": "Unidentified counterparty",
  "reportDashboard.noRanking": "No ranking data",
  "reportDashboard.completedDetails": "Completed order details",
  "reportDashboard.paginationSummary":
    "{total} records · Page {page} · Queried at {time}",
  "reportDashboard.noRecords": "No completed orders match these filters",
  "reportDashboard.orderNumber": "Order no.",
  "reportDashboard.createdAt": "Order creation date",
  "reportDashboard.ownCompany": "Own company",
  "reportDashboard.customer": "Customer",
  "reportDashboard.supplier": "Supplier",
  "reportDashboard.partNumber": "Part no.",
  "reportDashboard.goodsName": "Product name",
  "reportDashboard.quantity": "Product quantity",
  "reportDashboard.amount": "Transaction amount",
  "reportDashboard.counterpartyId": "Customer/supplier ID",
  "reportDashboard.counterparty": "Customer/supplier",
  "reportDashboard.quantityUnit": "Quantity unit",
  "reportDashboard.currency": "Currency",
  "reportDashboard.exactAmount": "Transaction amount (exact decimal)",
  "reportDashboard.salesSheet": "Sales details",
  "reportDashboard.purchaseSheet": "Purchase details",
  "reportDashboard.exportFilename": "Completed-order-dashboard.xlsx",
  "reportDashboard.unitPieces": "pcs",
  "reportDashboard.unitTrays": "trays",
  "reportDashboard.unitUnknown": "Unspecified unit",
  "reportDashboard.readFailed": "Could not load the dashboard",
  "reportDashboard.recordsFailed": "Could not load the details",
  "reportDashboard.exportFailed":
    "Could not export the dashboard. Please try again",
  "reportDashboard.companiesFailed": "Could not load the company list",
  "reportDashboard.companiesInvalid": "Invalid company list response",
  "reportDashboard.workbookInvalid":
    "The report endpoint did not return a valid Excel file",
  "reportDashboard.workbookEmpty": "The report endpoint returned an empty file",
  "reportDashboard.responseInvalid": "Invalid dashboard response",
  "reportDashboard.invalidPart": "Invalid dashboard query type",
  "reportDashboard.exportInvalid":
    "The dashboard export did not return a valid file",
  "reportDashboard.errorLoginRequired": "Please sign in first",
  "reportDashboard.errorNoAccess":
    "Your account does not have access to the data dashboard",
  "reportDashboard.errorInvalidReportType": "Invalid report type",
  "reportDashboard.errorReportTypeForbidden":
    "You do not have access to this report type",
  "reportDashboard.errorNoCompanyScope":
    "No accessible company scope is configured",
  "reportDashboard.errorCompanyForbidden":
    "The company is outside your authorized scope",
  "reportDashboard.errorDateOrderInvalid":
    "The start date must not be later than the end date",
  "reportDashboard.errorPageInvalid": "Pagination parameters are out of range",
  "reportDashboard.errorCurrencyInvalid": "Invalid currency",
  "reportDashboard.errorSourceInvalid": "Invalid business category",
  "reportDashboard.errorSourceCurrencyConflict":
    "The business category conflicts with the currency",
  "reportDashboard.errorCustomerInvalid": "Invalid customer",
  "reportDashboard.errorDateRangeInvalid":
    "The date is outside the supported database range",
  "reportDashboard.errorDateFormatInvalid":
    "Enter a valid date in yyyy-MM-dd format",
  "reportDashboard.errorFilterTooLong": "The filter value is too long",
  "reportDashboard.errorTrendLimitExceeded":
    "The trend range is too large. Narrow the date or unit range",
  "reportDashboard.errorExportLimitExceeded":
    "The export exceeds 10000 records. Narrow your filters",
  "reportDashboard.errorUnavailable":
    "Dashboard data is temporarily unavailable. Please try again",
  "reportDashboard.errorInvalidArgument":
    "Invalid dashboard request parameters. Please check and try again",
  "reportDashboard.errorFailed":
    "The dashboard operation failed. Please try again later",
  "reportDashboard.viewLoadingData": "Loading data",
  "reportDashboard.viewDataLoaded": "Data loaded",
  "reportDashboard.viewValue0ItemsToCheck": "{value0} items to check",
  "reportDashboard.viewServerReports": "Server reports",
  "reportDashboard.viewSelectReport": "Select report",
  "reportDashboard.viewAddData": "Add data",
  "reportDashboard.viewUploadExcel": "Upload Excel",
  "reportDashboard.viewRefreshData": "Refresh data",
  "reportDashboard.viewLoadSourceWorksheetsForChecking":
    "Load source worksheets for checking",
  "reportDashboard.viewExportCurrentData": "Export current data",
  "reportDashboard.viewCouldNotLoadReportData": "Could not load report data",
  "reportDashboard.viewFiltersHaveChangedPreparingNewResultsOrWaitingForACompletePeriodPreviousResultsAreStillShown":
    "Filters have changed. Preparing new results or waiting for a complete period; previous results are still shown.",
  "reportDashboard.viewLiveStatisticsUseCompletedOrderJSONDataLegacyExcelWorksheetsAreLoadedOnlyForCheckingNotForSalesTotalsRankingsOrTrendsCNYBusinessRemainsUnclassifiedTaxIsNotInferred":
    "Live statistics use completed-order JSON data. Legacy Excel worksheets are loaded only for checking, not for sales totals, rankings or trends. CNY business remains unclassified; tax is not inferred.",
  "reportDashboard.viewFilters": "Filters",
  "reportDashboard.viewFilterTheDashboardByTimeValue0AndValue1Model":
    "Filter the dashboard by time, {value0} and {value1} model",
  "reportDashboard.viewClearFilters": "Clear filters",
  "reportDashboard.viewDateRange": "Date range",
  "reportDashboard.viewSelectPeriod": "Select period",
  "reportDashboard.viewSelectAPeriod": "Select a period",
  "reportDashboard.viewCustomDates": "Custom dates",
  "reportDashboard.viewTo": "to",
  "reportDashboard.viewStartDate": "Start date",
  "reportDashboard.viewEndDate": "End date",
  "reportDashboard.viewValue0Model": "{value0} model",
  "reportDashboard.viewQuantityChartUnit": "Quantity chart unit",
  "reportDashboard.viewCurrentScopeValue0": "Current scope: {value0}",
  "reportDashboard.viewShareDenominatorTotalValue1ForValue0TheSameBusinessSourceAndCurrency":
    "Share denominator: total {value1} for {value0}, the same business source and currency",
  "reportDashboard.viewTheDenominatorDoesNotNarrowWithValue0OrModelSelectionCNYAndUSDAreCalculatedSeparately":
    "The denominator does not narrow with {value0} or model selection. CNY and USD are calculated separately",
  "reportDashboard.viewNoAmountDataForThisDateRange":
    "No amount data for this date range",
  "reportDashboard.viewBusinessTrendsAndComposition":
    "Business trends and composition",
  "reportDashboard.viewViewValue0QuantityChangesAndCompositionByBusinessSource":
    "View {value0} quantity changes and composition by business source",
  "reportDashboard.viewValue0QuantityTrend": "{value0} quantity trend",
  "reportDashboard.viewValidDetailQuantitiesGroupedByValue0Month":
    "Valid detail quantities grouped by {value0} month",
  "reportDashboard.viewValue0UnitValue1": "{value0} unit: {value1}",
  "reportDashboard.viewALogarithmicScaleIsUsedForLargeMonthlyDifferencesLabelsShowActualQuantities":
    "A logarithmic scale is used for large monthly differences. Labels show actual quantities",
  "reportDashboard.viewNoTrendData": "No trend data",
  "reportDashboard.viewQuantityByBusinessSource": "Quantity by business source",
  "reportDashboard.viewValue0QuantityShareByBusinessSource":
    "{value0} quantity share by business source",
  "reportDashboard.viewTotalValue0": "Total {value0}",
  "reportDashboard.viewAmountAnalysisAndValue0Ranking":
    "Amount analysis and {value0} ranking",
  "reportDashboard.viewValue0CompositionAndTopValue1InTheOriginalCurrency":
    "{value0} composition and top {value1} in the original currency",
  "reportDashboard.viewBusinessValue0": "Business {value0}",
  "reportDashboard.viewSameCurrencyComparisonNoExchangeRateConversion":
    "Same-currency comparison; no exchange-rate conversion",
  "reportDashboard.viewValue0RecordsValue1Value2":
    "{value0} records · {value1} {value2}",
  "reportDashboard.viewRankedInTheSelectedCurrencyUsingOriginalAmounts":
    "Ranked in the selected currency using original amounts",
  "reportDashboard.viewModelsAndDataCompleteness":
    "Models and data completeness",
  "reportDashboard.viewModelPopularityAndCoverageOfKeyBusinessFields":
    "Model popularity and coverage of key business fields",
  "reportDashboard.viewTop6Value0Models": "Top 6 {value0} models",
  "reportDashboard.viewTop5Value0Models": "Top 5 {value0} models",
  "reportDashboard.viewModelPopularityByValue0Quantity":
    "Model popularity by {value0} quantity",
  "reportDashboard.viewPaidRecords": "Paid records",
  "reportDashboard.viewValue0Records": "{value0} records",
  "reportDashboard.viewInvoicedRecords": "Invoiced records",
  "reportDashboard.viewRecordsAwaitingPayment": "Records awaiting payment",
  "reportDashboard.viewCustomerOrderProvided": "Customer order provided",
  "reportDashboard.viewShipmentDetailsProvided": "Shipment details provided",
  "reportDashboard.viewReceivingBankProvided": "Receiving bank provided",
  "reportDashboard.viewPurchaseCostIncludingTax": "Purchase cost including tax",
  "reportDashboard.viewPurchaseCostExcludingTax": "Purchase cost excluding tax",
  "reportDashboard.viewTaxDifference": "Tax difference",
  "reportDashboard.viewPaymentDetailsProvided": "Payment details provided",
  "reportDashboard.viewWarehouseReceiptProvided": "Warehouse receipt provided",
  "reportDashboard.viewInputInvoiceDateProvided": "Input invoice date provided",
  "reportDashboard.viewCompleteValue0Details": "Complete {value0} details",
  "reportDashboard.viewShowingValue0Value1Records":
    "Showing {value0} / {value1} records",
  "reportDashboard.viewSearchSupplierModelOrderNo":
    "Search supplier, model, order no.…",
  "reportDashboard.viewDateAndBusinessSourceArePinnedScrollHorizontallyForMoreFieldsSelectARowForFullDetails":
    "Date and business source are pinned. Scroll horizontally for more fields; select a row for full details",
  "reportDashboard.viewBusinessSource": "Business source",
  "reportDashboard.viewNo": "No.",
  "reportDashboard.viewGoodsName": "Goods name",
  "reportDashboard.viewQuantity": "Quantity",
  "reportDashboard.viewUnitPrice": "Unit price",
  "reportDashboard.viewSalesAmount": "Sales amount",
  "reportDashboard.viewTotalAmount": "Total amount",
  "reportDashboard.viewBusinessType": "Business type",
  "reportDashboard.viewSalesperson": "Salesperson",
  "reportDashboard.viewReceivingBank": "Receiving bank",
  "reportDashboard.viewPaymentMode": "Payment mode",
  "reportDashboard.viewCustomerOrderNo": "Customer order no.",
  "reportDashboard.viewShipmentTimeMethod": "Shipment time / method",
  "reportDashboard.viewRemarks": "Remarks",
  "reportDashboard.viewActions": "Actions",
  "reportDashboard.viewView": "View",
  "reportDashboard.viewBusinessRecords": "Business records",
  "reportDashboard.viewViewOriginalShipmentReturnAndBusinessConfigurationRecords":
    "View original shipment, return and business configuration records",
  "reportDashboard.viewAddShipmentReturn": "Add shipment / return",
  "reportDashboard.viewAddConfiguration": "Add configuration",
  "reportDashboard.viewShipmentReturnRecords": "Shipment / return records",
  "reportDashboard.viewQuantityAwaitingReturn": "Quantity awaiting return",
  "reportDashboard.viewValue0Pcs": "{value0} pcs",
  "reportDashboard.viewRecordsToCheck": "Records to check",
  "reportDashboard.viewValue0Items": "{value0} items",
  "reportDashboard.viewBusinessConfiguration": "Business configuration",
  "reportDashboard.viewFromSheet4ReferenceQuantityPackagingDetailsRemarksAndStatus":
    "From Sheet4: reference, quantity, packaging details, remarks and status",
  "reportDashboard.viewHReferenceAdjustment": "H reference / adjustment",
  "reportDashboard.viewPackagingDetails": "Packaging details",
  "reportDashboard.viewStatus": "Status",
  "reportDashboard.viewPackagingCheck": "Packaging check",
  "reportDashboard.viewDifferenceValue0Pcs": "Difference: {value0} pcs",
  "reportDashboard.viewMatched": "Matched",
  "reportDashboard.viewBusinessConfigurationRecords":
    "Business configuration records",
  "reportDashboard.viewFromSheet1BusinessTypeSalespersonAndPaymentModeFromTheSameSourceRow":
    "From Sheet1: business type, salesperson and payment mode from the same source row",
  "reportDashboard.viewValue0RecordsInTotal": "{value0} records in total",
  "reportDashboard.viewSourceRowNo": "Source row no.",
  "reportDashboard.viewNoConfiguration": "No configuration",
  "reportDashboard.viewConfigurationFollowsSourceRowsEmptyCellsRemainEmptyValuesAreNotShiftedToFillGaps":
    "Configuration follows source rows. Empty cells remain empty; values are not shifted to fill gaps.",
  "reportDashboard.viewSourceWorksheets": "Source worksheets",
  "reportDashboard.viewAllExcelWorksheetsAreRetainedForSourceVerification":
    "All Excel worksheets are retained for source verification",
  "reportDashboard.viewSourceValue0RowsValue1ColumnsHeaderDetectedAtRowValue2":
    "Source: {value0} rows × {value1} columns · Header detected at row {value2}",
  "reportDashboard.viewSemanticHeadersScrollHorizontallyToViewAllValue0Columns":
    "Semantic headers; scroll horizontally to view all {value0} columns",
  "reportDashboard.viewEdit": "Edit",
  "reportDashboard.viewThisWorksheetIsEmpty": "This worksheet is empty",
  "reportDashboard.viewParsingComplete": "Parsing complete",
  "reportDashboard.viewWorksheet": "Worksheet",
  "reportDashboard.viewValue0Details": "{value0} details",
  "reportDashboard.viewItemsToCheck": "Items to check",
  "reportDashboard.viewImportMode": "Import mode",
  "reportDashboard.viewReplaceCurrentData": "Replace current data",
  "reportDashboard.viewAppendAndDeduplicate": "Append and deduplicate",
  "reportDashboard.viewValue0RowValue1": "{value0} row {value1}",
  "reportDashboard.viewCancel": "Cancel",
  "reportDashboard.viewConfirmImport": "Confirm import",
  "reportDashboard.viewAddReportData": "Add report data",
  "reportDashboard.viewShipmentReturn": "Shipment / return",
  "reportDashboard.viewBasicInformation": "Basic information",
  "reportDashboard.viewEnterQuantity": "Enter quantity",
  "reportDashboard.viewEnterUnitPrice": "Enter unit price",
  "reportDashboard.viewOptional": "Optional",
  "reportDashboard.viewIfEmptyCalculateQuantityUnitPrice":
    "If empty, calculate quantity × unit price",
  "reportDashboard.viewBusinessInformation": "Business information",
  "reportDashboard.viewSettlementAndRemarks": "Settlement and remarks",
  "reportDashboard.viewShipmentAndReturnDetails": "Shipment and return details",
  "reportDashboard.viewRecordStatus": "Record status",
  "reportDashboard.viewNormal": "Normal",
  "reportDashboard.viewAwaitingReturn": "Awaiting return",
  "reportDashboard.viewShipmentReduction": "Shipment reduction",
  "reportDashboard.viewForExample15004Packs": "For example: 1500*4 packs",
  "reportDashboard.viewForExampleFundedPurchasing":
    "For example: funded purchasing",
  "reportDashboard.viewEnterSalesperson": "Enter salesperson",
  "reportDashboard.viewForExampleCollectionAndPaymentOnBehalf":
    "For example: collection and payment on behalf",
  "reportDashboard.viewSaveAndRefreshDashboard": "Save and refresh dashboard",
  "reportDashboard.viewDetailsToCheck": "Details to check",
  "reportDashboard.viewValue0RowValue1Label": "{value0} · Row {value1}",
  "reportDashboard.viewToBeConfirmed": "To be confirmed",
  "reportDashboard.viewBusinessReference": "Business reference",
  "reportDashboard.viewEnteredValue": "Entered value",
  "reportDashboard.viewCalculatedValue": "Calculated value",
  "reportDashboard.viewDifference": "Difference",
  "reportDashboard.viewReasonForChecking": "Reason for checking",
  "reportDashboard.viewCheckShipment": "Check shipment",
  "reportDashboard.viewEditSourceData": "Edit source data",
  "reportDashboard.viewWorksheetValue0": "Worksheet: {value0}",
  "reportDashboard.viewSourceRowValue0": "Source row: {value0}",
  "reportDashboard.viewBusinessIdentifierValue0":
    "Business identifier: {value0}",
  "reportDashboard.viewImportAndChangeHistory": "Import and change history",
  "reportDashboard.viewImportHistory": "Import history",
  "reportDashboard.viewValue0Value1Records": "{value0} {value1} records",
  "reportDashboard.viewValue0Shipments": "{value0} shipments",
  "reportDashboard.viewValue0ItemsToCheckLabel": "{value0} items to check",
  "reportDashboard.viewNoImportHistory": "No import history",
  "reportDashboard.viewChangeHistory": "Change history",
  "reportDashboard.viewDataChange": "Data change",
  "reportDashboard.viewOperatorValue0": "Operator: {value0}",
  "reportDashboard.viewDataOwnerValue0": "Data owner: {value0}",
  "reportDashboard.viewNoChangeHistory": "No change history",
  "reportDashboard.viewCNYUnclassified": "CNY / unclassified",
  "reportDashboard.viewCountedByCompletedOrderProductDetailRecordsNotContracts":
    "Counted by completed-order product detail records, not contracts",
  "reportDashboard.viewDeduplicatedByCustomerSupplierIDEntitiesWithTheSameNameAreCountedSeparately":
    "Deduplicated by customer/supplier ID; entities with the same name are counted separately",
  "reportDashboard.viewDifferentQuantityUnitsAreNotAddedTogether":
    "Different quantity units are not added together",
  "reportDashboard.viewAllTime": "All time",
  "reportDashboard.viewMonthly": "Monthly",
  "reportDashboard.viewQuarterly": "Quarterly",
  "reportDashboard.viewHalfYearly": "Half-yearly",
  "reportDashboard.viewYearly": "Yearly",
  "reportDashboard.viewCustom": "Custom",
  "reportDashboard.viewCustomPeriod": "Custom period",
  "reportDashboard.viewAllValue0": "All {value0}",
  "reportDashboard.viewAllValue0Models": "All {value0} models",
  "reportDashboard.viewOneValue0OneModel": "One {value0} + one model",
  "reportDashboard.viewSelectValue0AndModel": "Select {value0} and model",
  "reportDashboard.viewSelectValue0AndModelToView":
    "Select {value0} and model to view",
  "reportDashboard.viewOneValue0": "One {value0}",
  "reportDashboard.viewNoValue0Selected": "No {value0} selected",
  "reportDashboard.viewSelectValue0ToView": "Select {value0} to view",
  "reportDashboard.viewOneProductModel": "One product model",
  "reportDashboard.viewNoModelSelected": "No model selected",
  "reportDashboard.viewSelectAModelToView": "Select a model to view",
  "reportDashboard.viewValidValue0Details": "Valid {value0} details",
  "reportDashboard.viewBlankExcelRowsWithoutAValidQuantityOrAmountAreExcluded":
    "Blank Excel rows without a valid quantity or amount are excluded",
  "reportDashboard.viewPartnerValue0": "Partner {value0}",
  "reportDashboard.viewValue0Entities": "{value0} entities",
  "reportDashboard.viewDeduplicatedByValue0Name":
    "Deduplicated by {value0} name",
  "reportDashboard.viewTotalValue0Quantity": "Total {value0} quantity",
  "reportDashboard.viewTotalCNYSales": "Total CNY sales",
  "reportDashboard.viewTotalCNYPurchaseCost": "Total CNY purchase cost",
  "reportDashboard.viewTotalUSDSales": "Total USD sales",
  "reportDashboard.viewTotalUSDPurchaseCost": "Total USD purchase cost",
  "reportDashboard.viewCNYCashBusiness": "CNY cash business",
  "reportDashboard.viewCNYTaxInclusiveBusiness": "CNY tax-inclusive business",
  "reportDashboard.viewCNYCash": "CNY cash",
  "reportDashboard.viewCNYTaxInclusive": "CNY tax-inclusive",
  "reportDashboard.viewSales": "Sales",
  "reportDashboard.viewPurchasing": "Purchasing",
  "reportDashboard.viewDate": "Date",
  "reportDashboard.viewModel": "Model",
  "reportDashboard.viewOrderDate": "Order date",
  "reportDashboard.viewOrderingCompany": "Ordering company",
  "reportDashboard.viewSalesQuantity": "Sales quantity",
  "reportDashboard.viewSalesUnitPrice": "Sales unit price",
  "reportDashboard.viewSalesAmountExcludingTax": "Sales amount excluding tax",
  "reportDashboard.viewPaymentReceivedAt": "Payment received at",
  "reportDashboard.viewInvoiceDate": "Invoice date",
  "reportDashboard.viewWarehouseReceiptNo": "Warehouse receipt no.",
  "reportDashboard.viewPurchaseDate": "Purchase date",
  "reportDashboard.viewSourceColumnC": "Source column C",
  "reportDashboard.viewOrderingAccount": "Ordering account",
  "reportDashboard.viewOrderingAccountSourceColumnC":
    "Ordering account / source column C",
  "reportDashboard.viewPurchaseModel": "Purchase model",
  "reportDashboard.viewPurchaseQuantity": "Purchase quantity",
  "reportDashboard.viewPurchaseUnitPrice": "Purchase unit price",
  "reportDashboard.viewCostExcludingTax": "Cost excluding tax",
  "reportDashboard.viewPaymentTime": "Payment time",
  "reportDashboard.viewInputInvoiceDate": "Input invoice date",
  "reportDashboard.viewPurchaseWarehouseReceiptNo":
    "Purchase warehouse receipt no.",
  "reportDashboard.viewSalesShareAnalysis": "Sales share analysis",
  "reportDashboard.viewPurchaseCostShareAnalysis":
    "Purchase cost share analysis",
  "reportDashboard.viewPaymentAndInvoiceCoverage":
    "Payment and invoice coverage",
  "reportDashboard.viewTaxAndFieldCoverage": "Tax and field coverage",
  "reportDashboard.viewPaymentInvoiceAndCustomerOrderInformation":
    "Payment, invoice and customer order information",
  "reportDashboard.viewTaxInclusiveBusinessCostsAndTextFieldCompleteness":
    "Tax-inclusive business costs and text field completeness",
  "reportDashboard.viewLogScale": "Log scale · ",
  "reportDashboard.viewNotConnected": "Not connected",
  "reportDashboard.viewTheSelectedCompanyIsOutsideTheAuthorizedOptions":
    "The selected company is outside the authorized options",
  "reportDashboard.viewTheSelectedCustomerIsOutsideTheCurrentScope":
    "The selected customer is outside the current scope",
  "reportDashboard.viewYourAccountDoesNotHavePermissionToViewReportData":
    "Your account does not have permission to view report data",
  "reportDashboard.viewReportDataAccessHasNotBeenConfiguredForYourAccount":
    "Report data access has not been configured for your account",
  "reportDashboard.viewJSONCompletedOrders": "JSON · Completed orders",
  "reportDashboard.viewQueriedAtValue0": "Queried at {value0}",
  "reportDashboard.viewExportFailed": "Export failed",
  "reportDashboard.viewSelectACompanyBeforeLoadingLegacyWorksheetsForChecking":
    "Select a company before loading legacy worksheets for checking",
  "reportDashboard.viewLegacyReportVerification": "Legacy report verification",
  "reportDashboard.viewCouldNotLoadLegacyWorksheetsForChecking":
    "Could not load legacy worksheets for checking",
  "reportDashboard.viewPurchaseAndSaleOnBehalf": "Purchase and sale on behalf",
  "reportDashboard.viewPurchasingWithAdvancePayment":
    "Purchasing with advance payment",
  "reportDashboard.viewFactoringCredit": "Factoring credit",
  "reportDashboard.viewReceivablesReport": "Receivables report",
  "reportDashboard.viewSalesScaleCustomerCompositionPaymentsInvoicesAndSourceWorksheets":
    "Sales scale, customer composition, payments, invoices and source worksheets",
  "reportDashboard.viewPayablesReport": "Payables report",
  "reportDashboard.viewPurchasingShipmentChecksBusinessDictionariesAndSourceWorksheets":
    "Purchasing, shipment checks, business dictionaries and source worksheets",
  "reportDashboard.viewCalculatedPackagingQuantityDiffersFromTheEnteredQuantity":
    "Calculated packaging quantity differs from the entered quantity",
  "reportDashboard.viewAmountDiffersFromQuantityUnitPrice":
    "Amount differs from quantity × unit price",
  "reportDashboard.viewOverview": "Overview",
  "reportDashboard.viewSourceData": "Source data",
  "reportDashboard.viewYourAccountCanOnlyViewReports":
    "Your account can only view reports",
  "reportDashboard.viewAllSalesModels": "All sales models",
  "reportDashboard.viewAllPurchaseModels": "All purchase models",
  "reportDashboard.viewTotalSalesQuantity": "Total sales quantity",
  "reportDashboard.viewTotalPurchaseQuantity": "Total purchase quantity",
  "reportDashboard.viewValue0NotProvided": "{value0} not provided",
  "reportDashboard.viewPackagingQuantityDiffersByValue0Pcs":
    "Packaging quantity differs by {value0} pcs",
  "reportDashboard.viewDataUpdatedButThisBrowserCannotSaveItPersistently":
    "Data updated, but this browser cannot save it persistently",
  "reportDashboard.viewThisWorksheetIsReadOnly": "This worksheet is read-only",
  "reportDashboard.viewThisAccountOrWorksheetCannotBeEdited":
    "This account or worksheet cannot be edited",
  "reportDashboard.viewNoChangesToSave": "No changes to save",
  "reportDashboard.viewSourceWorksheetNotFound": "Source worksheet not found",
  "reportDashboard.viewCurrentUser": "Current user",
  "reportDashboard.viewSourceDataUpdatedAndDashboardRecalculated":
    "Source data updated and dashboard recalculated",
  "reportDashboard.viewCouldNotSave": "Could not save",
  "reportDashboard.viewOnlyXlsxOrXlsFilesAreSupported":
    "Only .xlsx or .xls files are supported",
  "reportDashboard.viewCouldNotParseExcelCheckTheFileFormat":
    "Could not parse Excel. Check the file format",
  "reportDashboard.viewRestoreSourceFile": "Restore source file",
  "reportDashboard.viewCouldNotRestore": "Could not restore",
  "reportDashboard.viewUpdatedValue0": "Updated {value0}",
  "reportDashboard.viewCNY": "CNY",
  "reportDashboard.viewUSD": "USD",
  "reportDashboard.viewUnnamedColumnValue0": "Unnamed column {value0}",
  "reportDashboard.readOnly": "Read-only",
  "reportDashboard.errorModelLimitExceeded":
    "The model range is too large. Narrow your filters",
  "reportDashboard.errorQuantityTrendLimitExceeded":
    "The quantity trend range is too large. Narrow your filters",
  "reportDashboard.exportUnitPrice": "Transaction unit price",
  "reportDashboard.exportSalesperson": "Salesperson from source report",
  "reportDashboard.exportContractNo":
    "Contract no. (source customer order column)",
  "reportDashboard.exportPaymentConfirmedAt": "Payment confirmation time",
  "reportDashboard.exportInvoiceUploadedAt": "Invoice upload time",
  "reportDashboard.exportShippedAt": "Shipment time",
  "reportDashboard.exportPaymentType": "Payment business type code",
  "reportDashboard.exportSourceRemarks": "Source contract/order remarks",
  "reportDashboard.selectYear": "Year",
  "reportDashboard.timeAxisUnit": "Time unit",
  "reportDashboard.timeAxisDay": "Day",
  "reportDashboard.timeAxisWeek": "Week",
  "reportDashboard.timeAxisMonth": "Month",
  "reportDashboard.timeAxisQuarter": "Season",
  "reportDashboard.timeAxisYear": "Year",
  "reportDashboard.timeAxisDailyUnavailable":
    "Daily trend data is unavailable. Update MTS API to view daily, weekly, seasonal or yearly trends.",
  "reportDashboard.categoryTopSix": "Top 6 products by category",
  "reportDashboard.categoryTopFive": "Top 5 products by category",
  "reportDashboard.rankPrevious": "Previous group",
  "reportDashboard.rankNext": "Next group",
  "reportDashboard.categoryDescription":
    "Ranked by quantity within current filters and one unit; shares use all part numbers in the category",
  "reportDashboard.categoryWAFER": "WAFER",
  "reportDashboard.categoryFLASH": "FLASH chips",
  "reportDashboard.categoryDDR": "DDR chips",
  "reportDashboard.categorySSD": "SSD",
  "reportDashboard.categoryMEMORYMODULE": "Memory modules",
  "reportDashboard.categoryUnit": "Quantity unit",
  "reportDashboard.businessSupplyChain": "Supply-chain orders",
  "reportDashboard.businessTrade": "Trade orders",
  "reportDashboard.businessUnclassified": "Unclassified",
  "reportDashboard.categoryUnconverted":
    "{count} records use packaging or unrecognized units and are excluded from category quantities because no conversion is available.",
  "reportDashboard.categoryLoading": "Loading category ranking…",
  "reportDashboard.categoryReadFailed":
    "Could not load category ranking. Please retry",
  "reportDashboard.categoryEmpty":
    "No completed orders for this category within the current filters",
  "reportDashboard.categoryRetry": "Retry",
  "reportDashboard.categoryAwaitingQuery":
    "Waiting for the current filter query",
  "reportDashboard.categoryUnknownQuantity":
    "Some quantities are missing; shares do not represent complete business totals",
  "reportDashboard.quantityChartLabel": "{value0} quantity trend chart",
  "reportDashboard.businessDate": "{value0} date",
  "reportDashboard.packagingDifferencesHint":
    "Found {value0} packaging quantity differences. Check the Packaging check column in shipment/return records.",
  "reportDashboard.paid": "Payment received",
  "reportDashboard.shipmentRecords": "Shipment records",
  "reportDashboard.importDifferencesHint":
    "Found {value0} differences; they will be retained and flagged after import.",
  "reportDashboard.businessLabel": "{value0} business",
  "reportDashboard.businessQuantity": "{value0} quantity",
  "reportDashboard.businessUnitPrice": "{value0} unit price",
  "reportDashboard.businessFullRecord": "Full {value0} record",
  "reportDashboard.validationDifferencesHint":
    "Found {value0} data differences. Check them against the source worksheets.",
  "reportDashboard.shipmentQuantityCheck": "Shipment quantity check",
  "reportDashboard.valueCheck": "{value0} check",
  "reportDashboard.enterField": "Enter {value0}",
  "reportDashboard.dateRangeText": "{value0} to {value1}",
  "reportDashboard.errorUnitLimitExceeded":
    "The quantity unit range is too large. Narrow your filters",
  "reportDashboard.unitSinglePiece": "pcs",
  "reportDashboard.salesCompany": "Sales company",
  "reportDashboard.orderingCompany": "Ordering company",
  "reportDashboard.allSalesCompanies": "All sales companies",
  "reportDashboard.allOrderingCompanies": "All ordering companies",
  "reportDashboard.receivablesTemplateFilename":
    "Receivables-import-template.xlsx",
  "reportDashboard.payablesTemplateFilename": "Payables-import-template.xlsx",
  "reportDashboard.receivablesExportFilename": "Receivables-data_{date}.xlsx",
  "reportDashboard.payablesExportFilename": "Payables-data_{date}.xlsx",
  "reportDashboard.errorCategoryInvalid": "Invalid product category",
  "reportDashboard.businessFactsTitle": "Live order business records",
  "reportDashboard.businessLegacyDeferred":
    "Legacy worksheet business records are not loaded. Use the reference action above when needed; unloaded shipment and return quantities are not zero.",
  "reportDashboard.businessFactsScope":
    "Uses order creation dates and the dashboard scope; status codes and facts below come from orders, not worksheet configuration",
  "reportDashboard.businessFactsCompany": "Our company",
  "reportDashboard.businessFactsModel": "Part number",
  "reportDashboard.businessFactsSalesperson": "Legacy report salesperson",
  "reportDashboard.businessFactsShipStatus": "Shipping status code",
  "reportDashboard.businessFactsCarrier": "Carrier",
  "reportDashboard.businessFactsTracking": "Tracking number",
  "reportDashboard.businessFactsUnavailable":
    "Actual shipped quantities, returns, warehouse references, customer POs and trade/supply-chain categories lack reliable order attribution. Order quantities and constants are not substitutes. Legacy worksheet records below are for reference only.",
  "reportDashboard.categoryResponseInvalid":
    "Invalid category ranking response",
});

export const messages = Object.freeze({ ...flows, ...reportDashboard });
